export default __webpack_public_path__ + "static/company-github-588b249357336bacd3cbc42b473e7d2f.png";